export default {
  finish: '今日完成',
  loading: '拼命加载中',
  submitTask: '提交',
  TempSaveTask: '临时保存',
  play: '播放',
  stop: '停止',
  pause: '暂停',
  zoomout: '缩小',
  zoomin: '放大',
  cut: '分段',
  add: '增加',
  regionPlay: '播放选中',
  regionDelete: '删除选中',
  valid: '有效',
  noValid: '无效',
  editor: '备注',
  rejectTask: '拒绝',
  acceptTask: '通过',
  // reviseAndAccept: '提交并通过',
  reviseTask: '修改',
  success: '成功',
  warning: '警告',
  error: '失败',
  errorMessage: '请检查所有标注是否都已完成',
  choise: '请选择',
  enter: '请输入',
  allWrong: '全部不合格',
  grouptask: '组任务',
  ques: '确认要修改并通过任务吗？',
  caveat: '警告',
  confirm: '确认',
  cancel: '取消',
  errorMessage2: '请填写拒绝理由到备注',
  openReport: '申诉',
  errorMessage3: '请按要求标注',
  reason: '申诉理由',
  dataDesc: '数据描述',
  skip: '跳过',
  wavTemp0: '播放增速',
  wavTemp1: '播放减速',
  wavTemp2: '添加时间戳',
  wavTemp3: '删除左侧时间戳',
  wavTemp4: '删除右侧时间戳',
  wavTemp5: '删除所有时间戳',
  wavTemp6: '播放选中段',
  wavTemp7: '全局问题',
  wavTemp8: '必选项',
  wavTemp9: '语音转写',
  wavTemp11:	'字数',
  wavTemp12:	'任务',
  wavTemp15:	'未完成',
  wavTemp18:	'所有的',
  wavTemp22:	'当前',
  wavTemp25:	'有效的',
  wavTemp26:	'无效的',
  wavTemp27:	'辅助上文',
  wavTemp28:	'辅助下文',
  wavTemp29:	'请输入转写内容',
  collectBtn01: '验证',
  rightData: '数据',
  rightBeizhu: '备注',
  delall: '确认删除全部标注？'
}



// WEBPACK FOOTER //
// ./src/lang/zh/public/taskPublic.js